import React from 'react'
import './WhyPartnerWithUsabg.component.scss'

const WhyPartnerWithUsabg = () => {
  return (
    <section className='why-partner-section'>
      <div className='why-partner-section__outer'>
        <div className='why-partner-section__inner'>
          <h2 className='why-partner-section__heading'>Why Agency Owners Partner With USABG</h2>
          <div className='why-partner-section__content-block'>
            <p>
              We understand that your agency is more than revenue &mdash; it&rsquo;s relationships, trust, and years of
              hard work. Our transition model is designed to honor that.
            </p>
            <p className='why-partner-section__spacer'>&nbsp;</p>
            <p>
              <strong className='why-partner-section__key-benefits-label'>Key Benefits:</strong>
            </p>
            <p className='why-partner-section__spacer'>&nbsp;</p>
            <ul className='why-partner-section__bullet-list'>
              <li>Continuity of client service</li>
              <li>Protection of your brand legacy</li>
              <li>Competitive acquisition structures</li>
              <li>Flexible transition timelines</li>
              <li>Ongoing income opportunities</li>
              <li>Administrative &amp; compliance support</li>
            </ul>
            <p className='why-partner-section__spacer'>&nbsp;</p>
          </div>

          <h2 className='why-partner-section__heading'>Is An Agency Transition Right For You?</h2>
          <div className='why-partner-section__content-block'>
            <p>We work with agency owners at many stages of their business lifecycle, including:</p>
            <p className='why-partner-section__spacer'>&nbsp;</p>
            <ul className='why-partner-section__bullet-list'>
              <li>Agents preparing for retirement</li>
              <li>Owners seeking succession plans</li>
              <li>Agencies looking to merge or scale</li>
              <li>Medicare-focused books of business</li>
              <li>Health &amp; life insurance agencies</li>
              <li>Solo producers with established client bases</li>
            </ul>
            <p className='why-partner-section__spacer'>&nbsp;</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyPartnerWithUsabg
